<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_PUBLISHING_WORKS_ACTION_OPTION_MERGE_WORKS"
        :close="closeDialog"
        maxDialogWidth="1000"
        maxCardHeight="800"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text-explanation'">
                        {{ $t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_EXPLANATION') }}
                    </v-col>
                </v-row>

<!-- WORKS OF THE MERGE, ONE OF THEM IS THE TARGET -->
                <v-row v-if="works.length > 0">
                    <v-col>
                        <v-radio-group v-model="targetAlvId" hide-details class="mt-0">
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>{{ $t('lang_PUBLISHING_WORKS_MERGE_CAPTION_TARGET_WORK') }}</th>
                                        <th>{{ $t('lang_GENERIC_CAPTION_ALVID') }}</th>
                                        <th>{{ $t('lang_PUBLISHING_WORKS_CAPTION_WORK_TITLE') }}</th>
                                        <th>{{ $t('lang_PUBLISHING_WORKS_CAPTION_STATUS') }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="work in works" :key="work.alvId">
                                        <td>
<!-- A STATUS-2 OR GHOST WORK CAN ONLY GO DOWN IN A MERGE, THE BACKEND DECIDES THAT AND SENDS canBeTarget -->
                                            <v-radio
                                                :value="work.alvId"
                                                :disabled="work.canBeTarget === false"
                                                hide-details
                                                color="generalCheckbox"
                                                :alvqa="alvqa + '-radio-target-' + work.alvId"
                                            />
                                        </td>
                                        <td :alvqa="alvqa + '-text-alvid-' + work.alvId">{{ work.alvId }}</td>
                                        <td>{{ work.song_title_primary }}</td>
                                        <td>{{ statusText(work.ver_status) }}</td>
                                        <td :alvqa="alvqa + '-text-target-hint-' + work.alvId">{{ targetHint(work) }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <v-row v-if="errorMsg !== null">
                    <v-col class="error--text" :alvqa="alvqa + '-text-error'">{{ $t(errorMsg) }}</v-col>
                </v-row>

<!-- WHAT THE MERGE WOULD DO -->
                <v-row v-if="showPreview">
                    <v-col>
                        <v-simple-table dense>
<!-- WITHOUT THE HEADERS THE DASH OF AN EMPTY TRANSFER READS LIKE A CONTRADICTION TO THE HINT NEXT TO IT -->
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="black--text font-weight-bold">{{ $t('lang_PUBLISHING_WORKS_MERGE_CAPTION_TRANSFERRED') }}</th>
                                    <th class="black--text font-weight-bold">{{ $t('lang_PUBLISHING_WORKS_MERGE_CAPTION_NOT_TRANSFERRED') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ $t('lang_GENERIC_CAPTION_OTHER_IDS') }}</td>
                                    <td :alvqa="alvqa + '-text-identifiers-transfer'">{{ identifiersTransfer }}</td>
                                    <td :alvqa="alvqa + '-text-identifiers-skipped'">{{ identifiersSkipped }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('lang_PUBLISHING_WORKS_CAPTION_OTHER_TITLES') }}</td>
                                    <td :alvqa="alvqa + '-text-titles-transfer'">{{ titlesTransfer }}</td>
                                    <td :alvqa="alvqa + '-text-titles-skipped'">{{ titlesSkipped }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('lang_PUBLISHING_WORKS_CAPTION_OTHER_PERSONS') }}</td>
                                    <td :alvqa="alvqa + '-text-other-persons-transfer'">{{ otherPersonsTransfer }}</td>
                                    <td :alvqa="alvqa + '-text-other-persons-skipped'">{{ otherPersonsSkipped }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('lang_PUBLISHING_WORKS_CAPTION_INSRUMENTATION') }}</td>
                                    <td :alvqa="alvqa + '-text-instrumentation'">{{ instrumentationText }}</td>
                                    <td>{{ instrumentationHint }}</td>
                                </tr>

<!-- SHARES ONLY ADD UP TO A WHOLE WHILE THEY STAY TOGETHER, SO THE USER PICKS ONE WORK -->
                                <tr>
                                    <td>{{ $t('lang_PUBLISHING_WORKS_CAPTION_ORIGINAL_SHARES') }}</td>
                                    <td colspan="2">
                                        <v-select
                                            v-model="sharesFromAlvId"
                                            :items="sharesOptions"
                                            item-text="text"
                                            item-value="value"
                                            hide-details
                                            dense
                                            class="merge-shares-select"
                                            :alvqa="alvqa + '-select-shares-from'"
                                        ></v-select>

<!-- THE WARNING IS THE CONSEQUENCE OF THE CHOICE, SO IT BELONGS UNDER THE SELECT AND NOT IN THE COLUMN OF SKIPPED ENTRIES -->
                                        <div class="error--text" :alvqa="alvqa + '-text-shares-hint'">{{ sharesHint }}</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>{{ $t('lang_GENERIC_CAPTION_METADATA') }}</td>
                                    <td>
                                        <div :alvqa="alvqa + '-text-filled-fields'">{{ filledFields }}</div>

<!-- THE RULE BEHIND THE ROW BELONGS UNDER THE FIELDS, THE SAME WAY THE SHARES WARNING SITS UNDER ITS SELECT -->
                                        <div class="error--text" :alvqa="alvqa + '-text-fields-hint'">{{ filledFieldsHint }}</div>
                                    </td>
                                    <td :alvqa="alvqa + '-text-conflicting-fields'">{{ conflictingFields }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('lang_PUBLISHING_WORKS_MERGE_CAPTION_LINKS') }}</td>
                                    <td class="merge-single-line" :alvqa="alvqa + '-text-links'">{{ linksText }}</td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td>{{ $t('lang_PUBLISHING_STATISTICS') }}</td>
                                    <td class="merge-single-line" :alvqa="alvqa + '-text-statistics-amount'">{{ statisticsAmountText }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>

<!-- THE SOURCE WORKS ARE GONE AFTERWARDS, SO THE PREVIEW HAS TO BE CONFIRMED -->
                <v-row v-if="showPreview">
                    <v-col>
                        <v-checkbox
                            v-model="isConfirmed"
                            color="generalCheckbox"
                            hide-details
                            class="mt-0"
                            :alvqa="alvqa + '-checkbox-confirm'"
                        >
                            <template v-slot:label>
                                <span
                                    class="black--text pt-1"
                                    :alvqa="alvqa + '-checkbox-confirm-text'"
                                >{{ confirmLabel }}</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                        <BaseButton
                            @click="start"
                            label="lang_PUBLISHING_WORKS_MERGE_CAPTION_START"
                            :disabled="!canStart"
                            :loading="isLoading"
                            :alvqa="alvqa + '-button-start'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "MergeWorksDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            alvqa: 'publishing-works-list-dialog-merge-works',
            // The main form status of a work as stored, mapped to the caption the status filter uses
            statusCaptions: {
                'ausregistriert': 'lang_PUBLISHING_WORKS_CAPTION_REGISTERED',
                'ghost': 'lang_PUBLISHING_WORKS_CAPTION_GHOST',
                'angemeldet': 'lang_PUBLISHING_WORKS_STATUS_IN_REGISTRATION_PROCESS',
                'status2': 'lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_GEMA_STATUS_2',
                'anzumelden': 'lang_PUBLISHING_WORKS_CAPTION_TO_BE_REGISTERED',
                'revision': 'lang_PUBLISHING_WORKS_CAPTION_TO_BE_UPDATED'
            },
            // Columns of the target work that can be filled from a source work, with their form labels
            // Same order as the panels of the work form, see getShareTypes in WorksEdit.vue
            shareTypes: ['manu', 'role', 'intl', 'own'],
            fieldCaptions: {
                'work_title_domestic': 'lang_PUBLISHING_WORKS_CAPTION_DOMESTIC_WORK_TITLE',
                'song_duration': 'lang_PUBLISHING_WORKS_CAPTION_DURATION',
                'song_sprache': 'lang_PUBLISHING_WORKS_CAPTION_LANGUAGE',
                'performer': 'lang_GENERIC_CAPTION_PERFORMER',
                'song_genre': 'lang_PUBLISHING_WORKS_CAPTION_STYLE',
                'work_catalogue_number': 'lang_PUBLISHING_WORKS_CAPTION_CATALOGUE_NUMBER',
                'isrc_sonstige_titel': 'lang_GENERAL_CAPTION_ISRC',
                'wer_notice': 'lang_GENERAL_CAPTION_NOTES',
                'work_points': 'lang_PUBLISHING_WORKS_CAPTION_WORK_POINTS'
            }
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowMergeWorksDialog },
            set(show) { this.$store.commit('setShowMergeWorksDialog', show) }
        },
        targetAlvId: {
            get() { return this.$store.getters.getMergeWorksTargetAlvId },
            set(alvId) { this.$store.commit('setMergeWorksTargetAlvId', alvId) }
        },
        sharesFromAlvId: {
            get() { return this.$store.getters.getMergeWorksSharesFromAlvId },
            set(alvId) { this.$store.commit('setMergeWorksSharesFromAlvId', alvId) }
        },
        isConfirmed: {
            get() { return this.$store.getters.getMergeWorksIsConfirmed },
            set(value) { this.$store.commit('setMergeWorksIsConfirmed', value) }
        },
        preview()       { return this.$store.getters.getMergeWorksPreview },
        errorMsg()      { return this.$store.getters.getMergeWorksErrorMsg },
        isLoading()     { return this.$store.getters.getMergeWorksIsLoading },
        works() {
            return this.preview === null ? [] : this.preview.works
        },
        showPreview() {
            return this.preview !== null
                && this.preview.targetWorkId !== null
                && this.errorMsg === null
        },
        canStart() {
            return this.showPreview && this.isConfirmed && !this.isLoading
        },
        confirmLabel() {
            // The user confirms a deletion, so the sentence names how many works it hits
            return this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_WARNING_CONFIRM_DELETION')
                       .replace('<join>', this.preview.sourceWorkIds.length)
        },
        identifiersTransfer() {
            let ids = this.preview.identifiers.transfer.map(entry => this.identifierText(entry))
            return ids.length === 0 ? this.$t('lang_GENERIC_CAPTION_NONE') : ids.join(', ')
        },
        identifiersSkipped() {
            return this.withReason(this.preview.identifiers.skipped.map(entry => this.identifierText(entry)), 'lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_ALREADY_PRESENT')
        },
        titlesTransfer() {
            let titles = this.preview.titles.transfer.map(entry => entry.title + ' (' + entry.type + ')')
            return titles.length === 0 ? this.$t('lang_GENERIC_CAPTION_NONE') : titles.join(', ')
        },
        titlesSkipped() {
            return this.withReason(this.preview.titles.skipped.map(entry => entry.title), 'lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_ALREADY_PRESENT')
        },
        otherPersonsTransfer() {
            let names = this.preview.otherPersons.transfer.map(entry => entry.name)
            return names.length === 0 ? this.$t('lang_GENERIC_CAPTION_NONE') : names.join(', ')
        },
        otherPersonsSkipped() {
            return this.withReason(this.preview.otherPersons.skipped.map(entry => entry.name), 'lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_ALREADY_PRESENT')
        },
        sharesOptions() {
            let target = this.preview.shares.rowsPerWork.find(entry => entry.workId === this.preview.targetWorkId)
            let options = [{
                text: this.$t('lang_PUBLISHING_WORKS_MERGE_OPTION_KEEP_TARGET_SHARES') + this.sharesBreakdown(target),
                value: null
            }]

            // A work without shares has nothing to offer, so it is not an option
            this.preview.shares.rowsPerWork.forEach(entry => {
                if(entry.workId === this.preview.targetWorkId || entry.rows === 0) return
                options.push({
                    // The bare ALV ID left it to the user to guess what choosing it would do
                    text: this.$t('lang_PUBLISHING_WORKS_MERGE_OPTION_TAKE_SHARES_FROM') + ' ' + entry.alvId + this.sharesBreakdown(entry),
                    value: entry.alvId
                })
            })

            return options
        },
        sharesHint() {
            // The warning follows the choice of the user, waiting for the server would let it linger
            if(this.sharesFromAlvId === null) return ''
            return this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_WARNING_SHARES_REPLACED')
        },
        instrumentationText() {
            let rows = this.preview.instrumentation.rows
            return rows === 0 ? this.$t('lang_GENERIC_CAPTION_NONE') : rows + ' ' + this.$t('lang_PUBLISHING_WORKS_CAPTION_INSTRUMENTS').trim()
        },
        instrumentationHint() {
            if(this.preview.instrumentation.targetHasOwn) {
                return this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_INSTRUMENTATION_OF_TARGET_KEPT')
            }
            return ''
        },
        filledFields() {
            let fields = this.preview.targetFields.fill.map(entry => this.fieldCaption(entry.column) + ': ' + entry.value)

            // The rule why other fields are missing here stands below, in filledFieldsHint
            if(fields.length > 0) return fields.join(', ')

            // A bare "none" leaves it open whether the target is complete or the other works are empty,
            // but without the empty columns of the backend neither statement may be claimed
            if(this.preview.targetFields.emptyColumns === undefined) return this.$t('lang_GENERIC_CAPTION_NONE')

            let empty = this.preview.targetFields.emptyColumns
            if(empty.length === 0) return this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_TARGET_FIELDS_ALL_SET')

            // Fields with contradicting values are named in the column of the skipped entries, not here
            let conflicting = this.preview.targetFields.conflicts.map(entry => entry.column)
            let withoutValue = empty.filter(column => conflicting.indexOf(column) === -1)

            return withoutValue.length === 0
                ? this.$t('lang_GENERIC_CAPTION_NONE')
                : this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_TARGET_FIELDS_SOURCES_EMPTY')
        },
        filledFieldsHint() {
            // Only a work that gets fields filled raises the question what happens to the rest
            if(this.preview.targetFields.fill.length === 0) return ''

            return this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_WARNING_TARGET_VALUES_KEPT')
        },
        conflictingFields() {
            return this.withReason(this.preview.targetFields.conflicts.map(entry => this.fieldCaption(entry.column)), 'lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_FIELDS_NOT_TRANSFERRED')
        },
        linksText() {
            return this.$t('lang_GENERIC_CAPTION_CONTRACTS') + ': ' + this.preview.contracts
                 + ', ' + this.$t('lang_GENERIC_CAPTION_DOMAIN_LABEL_TRACKS') + ': ' + this.preview.tracks
                 + ', ' + this.$t('lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_SHEETS') + ': ' + this.preview.sheets
        },
        statisticsAmountText() {
            // The backend keeps the amount on the scale of the column, the user wants to read money
            let amount = Number(this.preview.statisticsAmount).toLocaleString(this.$i18n.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })

            // The statistics page labels its sum with the home currency of the account, so this one does too
            let currency = String(this.$store.getters.getSelectedCurrency).toUpperCase()

            // A bare amount leaves the user guessing what happens to it
            return amount + ' ' + currency + ' (' + this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_TRANSFERRED_TO_TARGET') + ')'
        }
    },
    watch: {
        works(works) {
            if(works.length === 0 || this.targetAlvId !== null) return

            // The lowest work id wins, which is the oldest registration and usually the version to keep
            this.targetAlvId = works.map(work => work.alvId).sort()[0]
        },
        targetAlvId(alvId) {
            if(alvId === null) return

            // The shares of the target are the default, so a new target starts that choice over
            this.sharesFromAlvId = null

            this.$store.dispatch('fetchMergeWorksPreview')
        }
    },
    methods: {
        statusText(status) {
            return this.statusCaptions[status] === undefined ? status : this.$t(this.statusCaptions[status])
        },
        identifierText(entry) {
            // A work number belongs to the source that issued it, the number alone is not identifiable
            let source = entry.sourceName === undefined ? '' : String(entry.sourceName).trim()

            return source === '' ? entry.sourceWorkId : source + ': ' + entry.sourceWorkId
        },
        withReason(values, langKey) {
            // The values first and the reason once behind them, repeating the reason per value only adds noise
            return values.length === 0 ? '' : values.join(', ') + ' (' + this.$t(langKey) + ')'
        },
        sharesBreakdown(entry) {
            // The panels of the work form are named MANU, ROLE, INTL and OWN, so the counts are named after them
            if(entry === undefined || entry.rowsByType === undefined) return ''

            // The work form lists the panels in this order, the dialog must not invent a different one
            let types = Object.keys(entry.rowsByType).sort((a, b) => this.shareTypeOrder(a) - this.shareTypeOrder(b))

            let parts = types.map(type => type.toUpperCase() + ' ' + entry.rowsByType[type])
            return parts.length === 0 ? '' : ' (' + parts.join(', ') + ')'
        },
        shareTypeOrder(type) {
            let order = this.shareTypes.indexOf(type)

            // A type the work form does not know goes last instead of jumping to the front
            return order === -1 ? this.shareTypes.length : order
        },
        targetHint(work) {
            // Compared against false so a backend that does not send the flag yet leaves every work selectable
            return work.canBeTarget === false ? this.$t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_INFO_NOT_POSSIBLE_AS_TARGET') : ''
        },
        fieldCaption(column) {
            return this.fieldCaptions[column] === undefined ? column : this.$t(this.fieldCaptions[column])
        },
        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelectedWorksAction', [])
        },
        start() {
            this.$store.dispatch('mergeWorks')
        }
    }
}
</script>

<style scoped>
/* These two cells carry short enumerations that read as one statement and must not be torn apart */
.merge-single-line {
    white-space: nowrap;
}

/* Vuetify sets table headers to 12px, which is unreadable for the column captions of the preview */
::v-deep th {
    font-size: 0.875rem !important;
}

/* The row captions name what the row is about and must not be broken across lines */
::v-deep td:first-child {
    white-space: nowrap;
}

/* The hints of the work table and of the preview belong under each other, and two separate tables
   only agree on that with the same width for their last column */
::v-deep th:last-child,
::v-deep td:last-child:not([colspan]) {
    width: 30%;
}
</style>
